import { useDebounceControl } from '../../hooks'
import TextInput from '../../ui/form/TextInput'
import Heading from '../../ui/Heading'
import { SearchIcon } from '../../ui/icons'
import Stack from '../../ui/Stack'
import { useTranslation } from 'react-i18next'
import { SearchTableProps } from './TableTypes'
import { FolderTable } from './FolderTable'
import { CursorTable } from './CursorTable'

export function Table<T extends Record<string, any>>(props: SearchTableProps<T>) {
    const { params, setParams, title, actions, description } = props
    const { t } = useTranslation()
    const [search, setSearch] = useDebounceControl(params.q ?? '', q => setParams({ ...params, q }))
    const columnSort = params.sort
        ? { sort: params.sort, direction: params.direction ?? 'asc' }
        : undefined
    const filters = []
    if (props.enableSearch) {
        filters.push(
            <TextInput
                key="search"
                name="search"
                value={search}
                placeholder={props.searchPlaceholder ?? t('search')}
                onChange={setSearch}
                hideLabel={true}
                icon={<SearchIcon />}
            />,
        )
    }

    if (props.filters && props.type !== 'folder') {
        filters.push(...props.filters)
    }

    return (
        <>
            {
                // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                (title || actions || description) && (
                    <Heading
                        size="h3"
                        title={title}
                        actions={actions}
                    >
                        {description}
                    </Heading>
                )
            }
            {
                filters.length > 0 && (
                    <Stack>
                        {filters}
                    </Stack>
                )
            }
            {props.type === 'folder'
                ? (
                    <FolderTable {...props}
                        results={props.results}
                        isLoading={!props.results}
                        columnSort={columnSort}
                        params={params}
                        setParams={setParams}
                    />
                )
                : (
                    <CursorTable {...props}
                        results={props.results}
                        isLoading={!props.results}
                        columnSort={columnSort}
                        params={params}
                        setParams={setParams}
                    />
                )
            }
        </>
    )
}
